export const Colors = {
    darkBlue: '#1e3c72',
    mediumBlue: '#2a5298',
    translucentWhite: 'rgba(255, 255, 255, 0.1)',
    translucentBlack: 'rgba(0, 0, 0, 0.1)',
    solidWhite: 'rgba(255, 255, 255, 1)',
    whiteOpacity: 'rgba(255, 255, 255, 0.23)',
    white: 'rgb(255, 255, 255)',
    red: '#f5365c',
    lightBlue: '#0481db',
    successGreen: '#24a46d',
    warningOrange: '#fb6340',
    hoverOrange: '#fa3a0e',
    hoverRed: '#ec0c38',
    hoverWhite: '#e6e6e6',
    yellow: '#ffd600',
    black: '#000',
    lightGray: '#ccc',
    darkGray: '#1e1e1e',
    pink: '#fc03ce',
    pinkGlow: '#fc0dd4',
    pinkGlowAlt: '#fc17d2',
    purple: "#b23cfd",
    orangeOpacity: "rgba(245, 149, 66, 0.75)",
    orange:  "rgba(245, 149, 66, 1)",
    orangeMedium: "#ff6a00"
  };
  